import {Updatable} from '@fantasmagames/core/src/update/Updatable';

export class Timer extends Updatable {
	protected _startTime: number = null;
	protected _currentTime: number;
	protected _callback: Function;
	protected _duration: number;

	constructor(callback: Function, duration: number, start?: boolean) {
		super(start);

		this._callback = callback;
		this._duration = duration;
		this._startTime = Date.now();
		this._currentTime = this._startTime;
	}

	public stopWithCallback(): void {
		super.stop();

		this._callback();
	}

	public start(): Timer {
		super.start();

		this._startTime = Date.now();
		this._currentTime = this._startTime;

		return this;
	}

	public update(dt: number): void {
		this._currentTime += dt;

		const time = this._currentTime;

		if (time - this._startTime > this._duration) {
			this._callback();
			this.stop();
		}
	}
}



// WEBPACK FOOTER //
// ./@fantasmagames/core/src/update/Timer.ts